export type RequestMethod = "GET" | "POST" | "DELETE" | "PATCH" | "PUT";
